/** @jsx jsx */
import { CloseIcon, Flex, Paragraph } from "@eworkit/iris";
import { FC, useCallback, useState } from "react";
import { useRouter } from "router";
import { jsx } from "theme-ui";

import { Icon } from "@/components/Icon";
import { fetchBanner, TBannerVisibility } from "@/data/banners";
import { useFetcher } from "@/hooks/http";

import { Container } from "../Container";

interface MaintenanceBannerProps {}

export const MaintenanceBanner: FC<MaintenanceBannerProps> = ({}) => {
  const router = useRouter();

  const [isOpen, setOpen] = useState(true);

  const bannerFetcher = useFetcher(fetchBanner, {}, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  if (!bannerFetcher.payload) {
    return null;
  }

  const banner = bannerFetcher.payload;

  if (!banner.icon || !banner.text) {
    return null;
  }

  if (!banner.visibility || banner.visibility === TBannerVisibility.HIDDEN || !isOpen) {
    return null;
  }

  if (banner.visibility === TBannerVisibility.AUTHORIZED_ONLY && !/\/app/.test(router.pathname)) {
    return null;
  }

  if (banner.visibility === TBannerVisibility.PUBLIC_ONLY && /\/app/.test(router.pathname)) {
    return null;
  }

  return (
    <Flex
      sx={{
        backgroundColor: banner.backgroundColor,
        color: banner.textAndIconColor,
        zIndex: "tooltip",
      }}>
      <Container>
        <Flex flexDirection="row" gap="sm">
          <Icon icon={banner.icon} color="inherit" size="md" />
          <Paragraph size="p-md">{banner.text}</Paragraph>
          <CloseIcon size="md" onClick={handleClose} sx={{ cursor: "pointer" }} />
        </Flex>
      </Container>
    </Flex>
  );
};
